import axios from "axios";
import { toast } from "sonner";

/**
 * Global 401 interceptor for admin API calls.
 * When the backend rejects a request as "Token expired" or otherwise 401,
 * we clear the local token, notify the user, and redirect to /admin/login
 * with a return URL so they can resume where they left off.
 *
 * Idempotent — safe to call multiple times; the interceptor is only attached once.
 */
let installed = false;

export function installAdminAuthInterceptor() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (r) => r,
    (error) => {
      const status = error?.response?.status;
      const detail = error?.response?.data?.detail;

      // Only react to auth failures on ADMIN endpoints — public endpoints
      // (like /api/pages/{slug}) can return 401 for unrelated reasons.
      const url = error?.config?.url || "";
      const isAdminCall = url.includes("/api/admin/") || url.includes("/api/auth/me");

      if (status === 401 && isAdminCall) {
        const isAuthPage = typeof window !== "undefined" && window.location.pathname.startsWith("/admin/login");
        if (!isAuthPage) {
          try { localStorage.removeItem("admin_token"); } catch (_) { /* storage may be blocked */ }
          const msg = detail === "Token expired"
            ? "Din session har gått ut. Logga in igen."
            : "Du måste logga in för att fortsätta.";
          toast.error(msg);
          const returnTo = window.location.pathname + window.location.search;
          const target = `/admin/login?returnTo=${encodeURIComponent(returnTo)}`;
          // Small delay so the toast is visible before navigation.
          setTimeout(() => { window.location.href = target; }, 400);
        }
      }
      return Promise.reject(error);
    }
  );
}
